import { BotIcon } from "./BotIcon.js";

interface ChatHeaderProps {
  botName: string;
  botAvatar?: string | null;
  onClose?: () => void;
  onNewChat?: () => void;
  whatsappUrl?: string | null;
}

export function ChatHeader({ botName, botAvatar, onClose, onNewChat, whatsappUrl }: ChatHeaderProps) {
  return (
    <div class="flex items-center justify-between px-4 py-3 border-b border-[var(--border)] bg-[var(--primary)]">
      <div class="flex items-center gap-2">
        <div class="size-8 rounded-full bg-[var(--primary-foreground)]/20 flex items-center justify-center overflow-hidden">
          {botAvatar ? (
            <img src={botAvatar} alt="" class="size-8 rounded-full object-cover" />
          ) : (
            <BotIcon class="size-4 text-[var(--primary-foreground)]" />
          )}
        </div>
        <span class="text-sm font-semibold text-[var(--primary-foreground)]">{botName}</span>
      </div>
      <div class="flex items-center gap-1">
        {whatsappUrl && (
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Chat on WhatsApp"
            title="Chat on WhatsApp"
            class="size-8 rounded-lg flex items-center justify-center text-[var(--primary-foreground)] hover:bg-[var(--primary-foreground)]/10 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary-foreground)]/50"
          >
            <svg class="size-4" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
          </a>
        )}
        {onNewChat && (
          <button
            onClick={onNewChat}
            aria-label="Start new chat"
            title="Start new chat"
            class="size-8 rounded-lg flex items-center justify-center text-[var(--primary-foreground)] hover:bg-[var(--primary-foreground)]/10 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary-foreground)]/50"
          >
            {/* Pencil/compose icon */}
            <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 20h9" />
              <path d="M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z" />
            </svg>
          </button>
        )}
        {onClose && (
          <button
            onClick={onClose}
            aria-label="Close chat"
            class="size-8 rounded-lg flex items-center justify-center text-[var(--primary-foreground)] hover:bg-[var(--primary-foreground)]/10 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary-foreground)]/50"
          >
            <svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
